var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"difficulty",class:[{ small: _vm.isSmall }, ("" + (_vm.status.toLowerCase()))]},[_c('span',{class:("log-icon-" + (_vm.level.toLowerCase()))}),_c('span',{staticClass:"log-icon-membership"})])}
var staticRenderFns = []

export { render, staticRenderFns }